export const MONTHLY_EXPENSES_TABS = [
    { value: "summary", label: "Resumen" },
    { value: "entries", label: "Movimientos" },
    { value: "recurring", label: "Servicios y recurrentes" },
    { value: "budgets", label: "Presupuestos" },
];
